import type {DirectoryItem, FileTreePagePayload} from '@github-ui/code-view-types'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

type TreeNavigationResponse = {
  payload: FileTreePagePayload
}

export type NormalizedTreePayload = {
  tree: {
    items: DirectoryItem[]
    totalCount: number
  }
}

export async function fetchTree({
  contentUrl,
  isDataRouterEnabled = false,
  path,
  tree,
}: {
  contentUrl: string
  isDataRouterEnabled?: boolean
  path: string
  tree: string
}) {
  if (isDataRouterEnabled) {
    return fetchTreeItems({contentUrl, path, tree})
  }

  const response = await verifiedFetchJSON(`${contentUrl}?noancestors=1`)

  if (!response.ok) {
    throw new Error(`Failed to fetch tree data: ${response.status} ${response.statusText}`)
  }

  const data: TreeNavigationResponse = await response.json()

  return {
    tree: {
      items: data.payload.tree.items,
      totalCount: data.payload.tree.totalCount,
    },
  }
}

async function fetchTreeItems({contentUrl, path, tree}: {contentUrl: string; path: string; tree: string}) {
  const response = await verifiedFetchJSON(contentUrl, {
    method: 'POST',
    body: {
      branch: tree,
      start: path,
      stop: path,
    },
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch tree data: ${response.status} ${response.statusText}`)
  }

  const data = await response.json()
  const loadedTree = data?.payload?.fileTree?.fileTree?.[path]

  if (!loadedTree) {
    throw new Error(`Unable to find payload for fileTree items at path: ${path}`)
  }

  return {
    tree: loadedTree,
  }
}
